import React from "react";

const Filter = ({ style }) => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.21973 2.11145H17.6044C18.6365 2.11145 19.4809 2.95586 19.4809 3.98792V6.05204C19.4809 6.80263 19.0118 7.74086 18.5427 8.20998L14.5083 11.7753C13.9453 12.2444 13.57 13.1826 13.57 13.9332V17.9676C13.57 18.5306 13.1947 19.2812 12.7256 19.5626L11.4121 20.407C10.1924 21.1576 8.50356 20.3132 8.50356 18.812V13.8394C8.50356 13.1826 8.12826 12.3382 7.75297 11.8691L4.18767 8.11616C3.71856 7.64704 3.34326 6.80263 3.34326 6.23969V4.08174C3.34326 2.95586 4.18767 2.11145 5.21973 2.11145Z"
      stroke="#7E858F"
      strokeWidth="2.11103"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4082 2.11145L5.78271 9.52351"
      stroke="#7E858F"
      strokeWidth="1.40735"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Filter;
